export enum BriefKeywordType {
  Topic = 'TOPIC',
  Filter = 'FILTER',
  Exclusion = 'EXCLUSION',
}
